import { call } from 'redux-saga/effects'
import { APIS } from '../../_config'
import { CallApi } from '../api/callApi'
import { ErrorResponse, SuccessResponse } from '../api/apiTypes'
import { trackError } from '../../utils/analytics/rumTracking'

export function* createSession<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const data = action.payload
        const resp = yield call(CallApi.POST, APIS.DS_AGENT.CREATE_SESSION, data, true)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        action?.onError({ message: e?.message || 'Failed to create DS agent session', status_code: 400, success: false })
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'createSession', action: action?.type })
    }
}

export function* chat<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const { session_id, ...data } = action.payload as { session_id: string; [key: string]: any }
        const resp = yield call(CallApi.POST, APIS.DS_AGENT.CHAT(session_id), data, true)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        action?.onError({ message: e?.message || 'Failed to chat with DS agent', status_code: 400, success: false })
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'chat', action: action?.type })
    }
}

export function* listSessions<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const resp = yield call(CallApi.GET, APIS.DS_AGENT.LIST_SESSIONS, action.payload, false, true)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        action?.onError({ message: e?.message || 'Failed to list DS agent sessions', status_code: 400, success: false })
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'listSessions', action: action?.type })
    }
}

export function* getSessionMessages<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const { session_id } = action.payload as { session_id: string }
        const resp = yield call(CallApi.GET, APIS.DS_AGENT.GET_SESSION_MESSAGES(session_id), {}, false, true)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        action?.onError({ message: e?.message || 'Failed to get DS agent session messages', status_code: 400, success: false })
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'getSessionMessages', action: action?.type })
    }
}

export function* deleteSession<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const { session_id } = action.payload as { session_id: string }
        const resp = yield call(CallApi.DELETE, APIS.DS_AGENT.DELETE_SESSION(session_id), {}, true)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        action?.onError({ message: e?.message || 'Failed to delete DS agent session', status_code: 400, success: false })
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'deleteSession', action: action?.type })
    }
}

export function* submitFeedback<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const data = action.payload
        const resp = yield call(CallApi.POST, APIS.DS_AGENT.SUBMIT_FEEDBACK, data, true)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        action?.onError({ message: e?.message || 'Failed to submit feedback', status_code: 400, success: false })
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'submitFeedback', action: action?.type })
    }
}
